import {useMediaQuery} from 'react-responsive';
import {breakpoints} from "Theme/breakpoints";

export const MQ_MAX_SMALL = breakpoints.values['medium'] - 1;
export const MQ_MIN_MEDIUM = breakpoints.values['medium'];
export const MQ_MAX_MEDIUM = breakpoints.values['large'] - 1;
export const MQ_MIN_LARGE = breakpoints.values['large'];
export const MQ_MAX_LARGE = breakpoints.values['xlarge'] - 1;
export const MQ_MIN_XLARGE = breakpoints.values['xlarge'];

export const MQMaxSmall = ({children, ignore = false}) => {
    const isMQMaxSmall = useMediaQuery({maxWidth: MQ_MAX_SMALL});
    if (ignore) return children;
    return isMQMaxSmall ? children : null;
};

export const MQMaxMedium = ({children, ignore = false}) => {
    const isMQMaxMedium = useMediaQuery({maxWidth: MQ_MAX_MEDIUM});
    if (ignore) return children;
    return isMQMaxMedium ? children : null;
};

export const MQMinMedium = ({children, ignore = false}) => {
    const isMQMinMedium = useMediaQuery({minWidth: MQ_MIN_MEDIUM});
    if (ignore) return children;
    return isMQMinMedium ? children : null;
};

export const MQMinLarge = ({children, ignore = false}) => {
    const isMQMinLarge = useMediaQuery({minWidth: MQ_MIN_LARGE});
    if (ignore) return children;
    return isMQMinLarge ? children : null;
};

export const MQMaxLarge = ({children, ignore = false}) => {
    const isMQMaxLarge = useMediaQuery({maxWidth: MQ_MAX_LARGE});
    if (ignore) return children;
    return isMQMaxLarge ? children : null;
};

export const MQMinXLarge = ({children, ignore = false}) => {
    const isMQMinXLarge = useMediaQuery({minWidth: MQ_MIN_XLARGE});
    if (ignore) return children;
    return isMQMinXLarge ? children : null;
};

export const MQMinCustom = ({children, minWidth = 0, ignore = false}) => {
    const isMQMinMedium = useMediaQuery({minWidth: minWidth});
    if (ignore) return children;
    return isMQMinMedium ? children : null;
};

export const useMediaQueryCurrentSize = () => {
    const isSmall = useMediaQuery({maxWidth: MQ_MAX_SMALL});
    const isMedium = useMediaQuery({minWidth: MQ_MIN_MEDIUM, maxWidth: MQ_MAX_MEDIUM});
    const isLarge = useMediaQuery({minWidth: MQ_MIN_LARGE});

    return {isSmall, isMedium, isLarge};
};

